/**
 * AT指令 - api
 * date:2022 04 16
 * author:brian
 */

 import httpRequest from '@/utils/request.js';

 /**获取报警触发列表接口 */
export const gatewayGetAT = (params = {}) => httpRequest.httpGet({
    url: '/service/gateway/getAT', params: {
        ...params
    }
})
 /**获取报警触发列表接口 */
export const gatewaySendAT = (data) => httpRequest.httpPost('/service/gateway/sendAT',data)